export const esLocale = {
  // Attendance
  attendanceEditForm: {
    timeRequired: 'La hora es requerida',
    reasonRequired: 'El motivo es requerido',
    reasonMaxLength: 'El motivo no puede exceder de 250 caracteres',
  },
  // Audit Reports
  auditReports: {
    noMatchingWorkers: 'No hay trabajadores que coincidan con la selección',
  },
  // Audit User Session
  auditLogin: {
    passwordRequired: 'Contraseña requerida',
    emailRequired: 'Correo electrónico requerido',
    title: 'Ingreso al Portal de Fiscalización: Iniciar sesión',
    subtitle: 'Ingresa tu correo electrónico y contraseña para entrar al portal.',
    email: 'Correo electrónico',
    password: 'Contraseña',
    submit: 'Iniciar sesión',
    forgotPassword: 'Solicitar Clave',
    emailInvalid: 'Correo electrónico no es válido',
    passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
    passwordEmailSent: 'Se ha enviado la contraseña a tu correo electrónico.',
  },
  // Calendar V2
  calendarV2: {
    viewToggle: {
      calendar: 'Vista Calendario',
      agenda: 'Vista Agenda',
    },
    title: 'Turnos',
    patientTitle: 'Turnos de Paciente {name}',
    professionalTitle: 'Turnos de Profesional {name}',
    vista: {
      label: 'Vista',
      daily: 'Diaria',
      weekly: 'Semanal',
    },
    groupBy: {
      label: 'Visión General',
      caregiver: 'Por Profesional',
      patient: 'Por Paciente',
    },
    today: 'Hoy',
    filters: 'Filtros',
    group: 'Grupo',
    groupLabel: 'Filtrar por grupo',
    patient: 'Paciente',
    caregiver: 'Profesional',
    career: 'Especialidad',
    withoutCareer: 'Sin Especialidad',
    noPatients: 'Sin pacientes asignados',
    noCaregivers: 'Sin profesionales asignados',
    selectWeeklyPrompt: 'Selecciona un profesional o paciente para ver su semana',
    noDayShifts: 'Sin turnos para este día',
    loadError: 'No se pudieron cargar los turnos. Intenta nuevamente.',
    continued: 'Continúa del día anterior',
    successMessage: 'Cambios guardados exitosamente!',
    hasReports: 'Tiene reportes',
    hasIncidents: 'Tiene incidentes',
  },
  // Classic shifts calendar (shifts-list + shifts-calendar-* children)
  shiftsCalendar: {
    title: 'Turnos',
    patientTitle: 'Turnos de Paciente {name}',
    professionalTitle: 'Turnos de Profesional {name}',
    successMessage: 'Cambios guardados exitosamente!',
    caregiverWithoutShifts: 'El profesional seleccionado no tiene turnos con el paciente en este período.',
    generatingPdf: 'Se está generando el PDF, puede tomar unos segundos...',
    generatingExcel: 'Se está generando el Excel, puede tomar unos segundos...',
    loadingShifts: 'Cargando turnos...',
    noShifts: 'No hay turnos asignados',
    caregiver: 'Profesional',
    patient: 'Paciente',
    withoutCareer: 'Sin especialidad',
    toolbar: {
      viewProfile: 'Ver Perfil',
      downloadPdf: 'Descargar PDF',
      downloadPdfWithRequirements: 'Descargar PDF con requerimientos',
      downloadExcel: 'Descargar Excel',
      today: 'Hoy',
      pickDate: 'Ir a una fecha',
      add: 'Agregar',
      recurrent: 'Recurrente',
      manual: 'Manual',
      stop: 'Detener',
      offerShift: 'Ofrecer Turno',
      recalculate: 'Recalcular turnos',
    },
    filters: {
      title: 'Filtros',
      group: 'Grupo',
      groupLabel: 'Filtrar por grupo',
      noPatients: 'Sin pacientes asignados',
      noCaregivers: 'Sin profesionales asignados',
      vista: {
        label: 'Vista',
        daily: 'Diaria',
        weekly: 'Semanal',
        monthly: 'Mensual',
      },
      groupBy: {
        label: 'Visión General',
        caregiver: 'Por Profesional',
        patient: 'Por Paciente',
      },
      career: 'Especialidad',
      withoutCareer: 'Sin Especialidad',
      advanced: 'Filtros Avanzados',
      price: 'Precio',
      cost: 'Costo',
      markedStatus: {
        all: 'Todos los turnos',
        marked: 'Solo turnos marcados',
        unmarked: 'Solo turnos no marcados',
      },
      apply: 'Filtrar',
      clear: 'Limpiar',
    },
    legend: {
      question: '¿Qué significan las letras?',
      day: 'D = Turno día de 08:00 a 20:00',
      night: 'N = Turno noche de 20:00 a 08:00',
      custom: 'P = Turno personalizado',
      fullDay: '24 = Turno de 24 horas',
      kinesiologist: 'K = Turno de Kinesiólogo',
      phonoaudiologist: 'F = Turno de Fonoaudiólogo',
    },
    shiftTooltip: {
      schedule: 'Horario: {time}',
      price: 'Precio: {price}',
      salaried: 'Trabajador contratado',
      caregiverCost: 'Pago Profesional (líquido): {cost}',
      taxBill: 'Honorarios: {taxBill}',
    },
    rowMenu: {
      viewProfile: 'Ver Perfil',
      viewProfileSubtitle: 'Información personal y configuración',
      editShifts: 'Editar Turnos',
      editShiftsSubtitle: 'Mantener los turnos y cambiar al profesional',
      stopShifts: 'Detener Turnos',
      stopShiftsSubtitle: 'Eliminar turnos desde una fecha',
    },
  },
  // Patient schedule blocks ("bloqueos de horario")
  scheduleBlocks: {
    menuItem: 'Nuevo bloqueo',
    rowTitle: 'Bloqueos de horario',
    cellLetter: 'B',
    newTitle: 'Nuevo bloqueo de horario',
    editTitle: 'Editar bloqueo de horario',
    kindToggle: {
      shift: 'Turno',
      block: 'Bloqueo',
    },
    patient: 'Paciente',
    startDate: 'Fecha inicio',
    startTime: 'Hora inicio',
    endDate: 'Fecha término',
    endTime: 'Hora término',
    description: 'Descripción',
    descriptionHint: 'Ej: hospitalización, Teletón, clases, salida',
    careers: 'Especialidades Bloqueadas',
    careersHint: 'Vacío = todas las especialidades',
    allCareers: 'Todas las especialidades',
    createdBy: 'Creado por {name}',
    submitNew: 'Crear bloqueo',
    submitEdit: 'Guardar cambios',
    close: 'Cerrar',
    delete: 'Eliminar bloqueo',
    deleteTitle: 'Eliminar bloqueo',
    deleteConfirmation: 'Los turnos dentro del período no se modifican. ¿Eliminar este bloqueo?',
    deleteConfirm: 'Eliminar',
    cancel: 'Cancelar',
    saveError: 'No se pudo guardar el bloqueo.',
    deleteError: 'No se pudo eliminar el bloqueo.',
    validation: {
      fieldRequired: 'Campo requerido',
      endAfterStart: 'El término debe ser posterior al inicio',
      descriptionMaxLength: 'La descripción no puede exceder 250 caracteres',
    },
    conflicts: {
      title: 'Turnos en este período',
      none: 'No hay turnos en este período',
      loading: 'Buscando turnos…',
      info: 'Estos turnos quedan dentro del bloqueo. Puedes guardar de todos modos.',
      more: '… y {count} turno(s) más',
    },
    shiftFlagTooltip: 'Dentro de un bloqueo: {description}',
    blockTooltip: {
      careers: 'Especialidades Bloqueadas: {careers}',
      edit: 'Clic para editar',
    },
  },
  auditRecoverPassword: {
    title: 'Ingreso al Portal de Fiscalización: Solicitar Clave',
    subtitle: 'Ingresa tu correo electrónico para recibir la contraseña de acceso.',
    email: 'Correo electrónico',
    submit: 'Enviar contraseña',
    backToLogin: 'Volver al inicio de sesión',
  },
  auditCaregiverLogin: {
    title: 'Ingreso al Portal de Asistencias de Trabajador: Iniciar sesión',
  },
  auditUserLogin: {
    title: 'Ingreso al Portal de Asistencias de Empleador: Iniciar sesión',
  },
  auditServiceCompanyLogin: {
    title: 'Ingreso al Portal de Asistencias de Empresa de Servicios: Iniciar sesión',
  },
  auditCaregiverChangeEmail: {
    title: 'Cambiar Correo Electrónico',
    currentEmail: 'Correo electrónico actual',
    newEmail: 'Nuevo Correo Electrónico',
    submit: 'Actualizar Correo',
    success: `Has modificado correctamente tu cuenta de correo electrónico. Recordar que para asegurar que recibas
      todas las notificaciones importantes del sistema de asistencia, es tu responsabilidad mantener operativa
      la cuenta de correo electrónico registrada y con espacio suficiente. Si en algún momento tienes problemas
      para recibir correos (por ejemplo, buzón lleno, clave olvidada o cualquier otro inconveniente), por favor
      informa a tu empleador de inmediato y modifica tu cuenta si es necesario. Esto garantiza que siempre estés
      al día con tu información de asistencia.`,
    close: 'Cerrar',
    emailDifferent: 'El nuevo correo no puede ser el mismo que el actual.',
  },
  auditContractDocument: {
    title: 'Documentos',
    description: 'Descripción Documento',
    documentType: 'Tipo de Documento',
    document: 'Documento',
    caregiver: 'Trabajador',
    caregiverDni: 'RUT',
    caregiverName: 'Nombre Trabajador',
    createdAt: 'Fecha de Creación',
    state: 'Estado',
    actions: 'Acciones',
    noDocuments: 'No hay documentos',
    add: 'Agregar Documento',
    documentTypes: {
      annex: 'Anexo',
      pact: 'Pacto',
      notification: 'Notificación',
    },
    sendConfirmation: 'Enviar Documento',
    approvalConfirmation: 'Aprobar Documento',
    rejectConfirmation: 'Rechazar Documento',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    signedPdfFailed: 'No se pudo generar el PDF con las firmas. El archivo disponible ' +
      'para descargar no incluye la página de firmas.',
    signedPdfStillPending: 'La generación del PDF firmado está tardando más de lo ' +
      'esperado. Recarga la página en unos minutos.',
  },
  auditContractDocumentForm: {
    createSubmit: 'Crear Documento',
    createTitle: 'Agregar Documento',
    updateSubmit: 'Actualizar Documento',
    updateTitle: 'Editar Documento',
    fieldRequired: 'Campo requerido',
    fileSizeLimit: 'El documento debe pesar máximo 30MB.',
  },
  auditRequestDocument: {
    title: 'Solicitudes',
    description: 'Descripción Solicitud',
    documentType: 'Tipo de Solicitud',
    document: 'Documento',
    caregiver: 'Trabajador',
    caregiverDni: 'RUT',
    caregiverName: 'Nombre Trabajador',
    createdAt: 'Fecha de Creación',
    state: 'Estado',
    actions: 'Acciones',
    noDocuments: 'No hay solicitudes',
    add: 'Agregar Solicitud',
    documentTypes: {
      holiday: 'Vacaciones',
      paidPermit: 'Permiso con Goce de Sueldo',
      unpaidPermit: 'Permiso sin Goce de Sueldo',
      overtimeCompensation: 'Compensación de Horas Extras',
      shiftChange: 'Cambio de Turno',
    },
    startDate: 'Fecha Inicio',
    endDate: 'Fecha Término',
    overtimeHours: 'Horas Extras',
    currentShift: 'Turno Actual',
    newShift: 'Turno Nuevo',
    shiftChangeReason: 'Motivo del Cambio de Turno',
    sendConfirmation: 'Enviar Solicitud',
    approvalConfirmation: 'Aprobar Solicitud',
    rejectConfirmation: 'Rechazar Solicitud',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
    rejectionReason: 'Motivo de Rechazo y Forma de Apelación',
    signedPdfFailed: 'No se pudo generar el PDF con las firmas. El archivo disponible ' +
      'para descargar no incluye la página de firmas.',
    signedPdfStillPending: 'La generación del PDF firmado está tardando más de lo ' +
      'esperado. Recarga la página en unos minutos.',
  },
  auditRequestDocumentForm: {
    createSubmit: 'Crear Solicitud',
    createTitle: 'Agregar Solicitud',
    updateSubmit: 'Actualizar Solicitud',
    updateTitle: 'Editar Solicitud',
    fieldRequired: 'Campo requerido',
    fileSizeLimit: 'El documento debe pesar máximo 30MB.',
  },
  // Base Service Prices
  baseServicePriceForm: {
    fieldRequired: 'Campo requerido',
    fieldPositive: 'Debe ser un número mayor a 0',
    priceAlreadyExists: 'El precio para este servicio ya está definido.',
    withTaxBillTitle: '¿Con boleta de honorarios?',
    yes: 'Sí',
    no: 'No',
  },
  bulkExports: {
    download: 'Descargar PDFs en ZIP',
    generating: 'Generando PDFs ({progress})...',
    started: 'Se está generando el archivo ZIP, puede tomar unos minutos...',
    completed: 'Descarga lista.',
    completedWithSkips: 'Descarga lista. {message}',
    failed: 'Hubo un error generando el archivo ZIP. Por favor, inténtalo nuevamente.',
    emptyCalendar: 'No hay turnos en el período seleccionado para exportar.',
  },
  // Caregivers
  caregiver: {
    idCode: 'Código',
    firstName: 'Nombre',
    lastName: 'Apellido',
    email: 'Correo electrónico',
    corporateEmail: 'Correo electrónico corporativo',
    phoneNumber: 'Número de teléfono',
    countryId: 'Nacionalidad',
    address: 'Dirección',
    dateOfBirth: 'Fecha de nacimiento',
    description: 'Experiencia y Estudios',
    dni: 'RUT',
    passportNumber: 'Número de Pasaporte',
    sex: 'Sexo',
    career: 'Especialidad',
    communeId: 'Comuna',
    comments: 'Observaciones',
    startsOn: 'Fecha de Inicio de Trabajo',
    endsOn: 'Fecha de Término de Trabajo',
    auditableFields: 'Información contractual para sistema de control de asistencias DT',
    auditableFieldsDescription: `Para poder acceder a los demas campos de la información contractual,
     debes seleccionar la opción "Con contrato".`,
    employmentContractType: 'Tipo de Contrato',
    workdayType: 'Tipo de Jornada',
    agreedOvertimeCompensation: 'Compensación de Horas Extra Pactada',
    compensationType: 'Tipo de Compensación',
    flexibleWorkingHours: 'Sujeto a Banda Horaria',
    exceptionalWorkdayResolution: 'Resolución Excepcional de Jornada',
    exceptionalWorkdayDate: 'Fecha de Resolución Excepcional de Jornada',
    exceptionalWorkdayText: 'Texto de Resolución Excepcional de Jornada',
    officeId: 'Oficina',
    serviceCompanyId: 'Empresa de Servicios Transitorios o Subcontratista',
    skills: 'Subespecialidades',
  },
  caregiverForm: {
    fieldRequired: 'Campo requerido',
    createTitle: 'Agregar Profesional',
    updateTitle: 'Editar Profesional',
    createSubmit: 'Agregar',
    updateSubmit: 'Guardar',
    male: 'Masculino',
    female: 'Femenino',
    invalidDni: 'El RUT ingresado no es válido',
    endsOnMustBeAfterStartsOn: 'La fecha de término debe ser posterior a la fecha de inicio',
    recordNotUnique: 'Ya existe un profesional con este correo. Si necesitas ayuda, por favor contacta a soporte.',
    addressRequiresLocation: 'Debe seleccionar una dirección válida',
    addressMap: 'Ajustar dirección en mapa',
    skillsHint: 'Subespecialidades certificadas de la especialidad que posee el profesional',
    confirm: 'Confirmar',
    sendAppAccess: 'Enviar enlace para crear contraseña (opcional)',
    sendAppAccessHint: 'Solo si no puede entrar a Kuido Care con su correo Google, Microsoft o Apple. ' +
      'Con esas cuentas entra directo, sin contraseña.',
    usesApp: 'Ya ingresa a Kuido Care.',
    sectionPersonalInfo: 'Información personal',
    sectionContactInfo: 'Contacto y dirección',
    sectionProfessionalInfo: 'Información profesional',
    sectionAdministrative: 'Información administrativa',
    employmentContractTypes: {
      taxBill: 'Con boleta de honorarios',
      contract: 'Con contrato',
      withoutContract: 'Sin contrato',
    },
    workdayTypes: {
      fixed: 'Fija',
      shifts: 'Por turnos',
      cyclic: 'Distribuida en ciclos',
      biweekly: 'Bisemanal',
      exceptional: 'Excepcional',
      partial: 'Parcial',
    },
    compensationTypes: {
      financial: 'Remuneración Económica',
      daysOff: 'Días Adicionales de Descanso',
    },
    AuditableDescription: {
      workdayType: 'Es el tipo de jornada por la cuál ha sido contratado el trabajador.',
      agreedOvertimeCompensation: `Este campo indica si el trabajador tiene un pacto de compensación de horas
      extras acordado y aprobado.`,
      compensationType: `Este campo define el tipo de compensación pactada con el trabajador: puede ser
      una remuneración económica o compensación mediante días de descanso adicionales.`,
      flexibleWorkingHours: `Este campo indica si el trabajador tiene permitido entrar y salir de sus turnos
      de manera flexible, cómo lo indica la dirección del trabajo.`,
      exceptionalWorkdayResolution: `Este campo debe completarse si el trabajador tiene una jornada excepcional
      de trabajo aprobada. Debe indicar el código/número de la resolución.`,
      exceptionalWorkdayDate: `Este campo debe completarse con la fecha en que se aprobó la resolución de jornada
      excepcional del trabajador.`,
      exceptionalWorkdayText: `Este campo permite agregar texto adicional o notas relacionadas con la resolución
      excepcional de jornada del trabajador.`,
      office: `Este campo debe asignar la oficina correspondiente al trabajador, a pesar de que este trabaje a
      domicilio.`,
      serviceCompany: `Este campo debe utilizarse para asignar la empresa de servicios transitorios, contratista o
      subcontratista del trabajador, considerando que éste trabajador no está contratado por ustedes directamente.`,
    },
  },
  caregiverDiscardForm: {
    title: 'Archivar Profesional',
    confirmation: `Estás a punto de archivar a este profesional.
      Si lo haces, este profesional dejará de aparecer en la vista de turnos.`,
    submit: 'Archivar',
    error: 'El profesional no se puede archivar porque aún esta activo, es decir, tiene turnos futuros asignados.',
  },
  caregiverUndiscardForm: {
    title: 'Desarchivar Profesional',
    confirmation: `Estás a punto de desarchivar a este profesional.
      Si lo haces, este profesional volverá a aparecer en la vista de turnos.`,
    submit: 'Desarchivar',
  },
  caregiverDocument: {
    name: 'Nombre',
    documentUrl: 'Documento',
    document: 'Documento',
  },
  caregiverDocumentForm: {
    fieldRequired: 'Campo requerido',
    createTitle: 'Agregar Documento',
    updateTitle: 'Editar Documento',
    createSubmit: 'Agregar',
    updateSubmit: 'Guardar',
    fileSizeLimit: 'El documento debe pesar máximo 30MB.',
  },
  caregiverDocumentDestroyForm: {
    title: 'Eliminar Documento',
    submit: 'Eliminar',
    confirmation: '¿Estás seguro que deseas eliminar este documento?',
  },
  passwordRecoverySuccess: {
    title: '¡Listo!',
    message: 'Si el correo está registrado, recibirás un enlace para crear o recuperar tu contraseña.',
    closeTab: 'Puedes cerrar esta pestaña sin problemas.',
  },
  passwordUpdateSuccess: {
    title: '¡Listo!',
    message: 'Tu contraseña quedó guardada. Ya puedes iniciar sesión en la app con tu correo y contraseña.',
    closeTab: 'Puedes cerrar esta pestaña sin problemas.',
  },
  // Charge Movements
  chargeMovement: {
    date: 'Fecha',
    movementType: 'Tipo de Movimiento',
    amount: 'Monto',
    description: 'Descripción',
  },
  chargeMovementForm: {
    fieldRequired: 'Campo requerido',
    createTitle: 'Agregar Movimiento',
    updateTitle: 'Editar Movimiento',
    createSubmit: 'Agregar',
    updateSubmit: 'Guardar',
    fieldPositive: 'Debe ser un número positivo',
    validDateRange: 'La fecha debe estar dentro del período seleccionado',
  },
  chargeMovementDestroyForm: {
    title: 'Eliminar Movimiento',
    submit: 'Eliminar',
    confirmation: '¿Estás seguro que deseas eliminar este movimiento?',
  },
  // Payment Movements
  paymentMovement: {
    date: 'Fecha',
    movementType: 'Tipo de Movimiento',
    amount: 'Monto',
    description: 'Descripción',
    withTaxBill: 'Incluir en la boleta de honorarios',
  },
  paymentMovementForm: {
    fieldRequired: 'Campo requerido',
    createTitle: 'Agregar Movimiento',
    updateTitle: 'Editar Movimiento',
    createSubmit: 'Agregar',
    updateSubmit: 'Guardar',
    fieldPositive: 'Debe ser un número positivo',
    validDateRange: 'La fecha debe estar dentro del período seleccionado',
    withTaxBillHint: 'El monto es líquido: se le suma la retención de impuestos en la boleta.',
  },
  paymentMovementDestroyForm: {
    title: 'Eliminar Movimiento',
    submit: 'Eliminar',
    confirmation: '¿Estás seguro que deseas eliminar este movimiento?',
  },
  // Patients
  patient: {
    idCode: 'Código',
    firstName: 'Nombre',
    lastName: 'Apellido',
    nickname: 'Apodo',
    address: 'Dirección',
    birthdate: 'Fecha de nacimiento',
    dni: 'RUT',
    passportNumber: 'Número de Pasaporte',
    weight: 'Peso (Kg)',
    sex: 'Sexo',
    medicalHistory: 'Antecedentes Médicos',
    surgicalHistory: 'Antecedentes Quirúrgicos',
    technicalAids: 'Ayudas Técnicas',
    insurances: 'Seguros y Convenios',
    comments: 'Observaciones',
    startsOn: 'Fecha de Inicio de Servicio',
    endsOn: 'Fecha de Término de Servicio',
    representative: 'Apoderados',
    representativeFirstName: 'Nombre',
    representativeLastName: 'Apellido',
    representativeEmail: 'Correo electrónico',
    representativeSendAppAccess: 'Enviar enlace para crear contraseña (opcional)',
    representativeSendAppAccessHint: 'Solo si no puede entrar a Kuido Familia con su correo Google, ' +
      'Microsoft o Apple. Con esas cuentas entra directo, sin contraseña.',
    representativeUsesApp: 'Ya ingresa a Kuido Familia.',
    representativeReceivesCharges: 'Recibe los cobros por correo',
    representativeReceivesChargesHint: 'Le llegan el correo de cobro y los DTE. Si ningún apoderado ' +
      'está marcado, los recibe el primero. Requiere correo.',
    representativePhoneNumber: 'Número de teléfono',
    representativeDni: 'RUT',
    representativeObservations: 'Observaciones',
    representativeObservationsInfo: 'Este campo es para poder agregar información relevante.' +
     ' Se mostrará en reportes de cobros, en la sección de apoderado.',
  },
  patientForm: {
    fieldRequired: 'Campo requerido',
    createTitle: 'Agregar Paciente',
    updateTitle: 'Editar Paciente',
    createSubmit: 'Agregar Paciente',
    updateSubmit: 'Guardar Paciente',
    male: 'Masculino',
    female: 'Femenino',
    invalidDni: 'El RUT ingresado no es válido',
    addressMap: 'Ajustar dirección en mapa',
    addressRequiresLocation: 'Debe seleccionar una dirección válida',
    representativeRecordNotUnique: `Ya existe un apoderado con este correo.
      Si necesitas ayuda, por favor contacta a soporte.`,
    atLeastOneRepresentative: 'Debes agregar al menos un apoderado.',
    emailFormat: 'El correo electrónico debe tener un formato válido.',
    locationExtended: 'Aumentar alcance para la marcación de turnos en Kuido Care.',
    sectionPersonalInfo: 'Información personal',
    sectionAddresses: 'Direcciones',
    sectionMedicalInfo: 'Información médica',
    sectionAdministrative: 'Información administrativa',
    addAddress: 'Agregar dirección',
    addressLabel: 'Etiqueta',
    addressLabelPlaceholder: 'ej. Casa, Oficina',
    addressSearchPlaceholder: 'Busca y selecciona una dirección…',
    addressesEmptyHint: 'Este paciente aún no tiene direcciones. Agrega una para habilitar la ' +
      'marcación de turnos y la planificación de rutas.',
    primaryAddress: 'Dirección principal',
    setAsPrimary: 'Marcar como principal',
    newAddress: 'Nueva dirección',
    locationExtendedLabel: 'Ampliar alcance de marcación',
    singlePrimaryAddress: 'Debes marcar exactamente una dirección principal.',
    selectExistingRepresentative: 'Seleccionar apoderado existente',
    addNewRepresentative: 'Agregar nuevo apoderado',
    weightRequired: 'El peso debe estar entre 1 y 350 kg',
    birthdateRequired: 'La fecha de nacimiento debe estar entre 01-01-1900 y hoy',
    endsOnMustBeAfterStartsOn: 'La fecha de término debe ser posterior a la fecha de inicio',
    serviceCategory: 'Categoría',
    serviceSubcategory: 'Subcategoría',
    serviceCategoryStartsOn: 'Categoría vigente desde',
    serviceCategoryStartsOnHint: 'Puede ser una fecha pasada o futura',
    serviceCategoryArchived: 'archivada',
    archivedRutConflict: 'Este RUT pertenece a un paciente archivado: {name} ' +
      '(archivado el {date}{reason}).',
    archivedRutConflictReason: ' · {reason}',
    reactivateArchived: 'Reactivar paciente',
    reactivateArchivedHint: 'Vuelve a Activos como nuevo ingreso, con su historial intacto.',
    reactivateError: 'No se pudo reactivar al paciente.',
  },
  serviceAssignments: {
    tabTitle: 'Categoría',
    timelineTitle: 'Historial de categorías',
    assignCta: 'Cambiar categoría',
    effectiveFrom: 'Vigente desde',
    effectiveFromHint: 'Puede ser una fecha pasada o futura',
    current: 'Vigente',
    noCategory: 'Sin categoría',
    empty: 'Este paciente no tiene historial de categorías.',
    sinceDate: 'Desde {date}',
    dateRange: '{from} — {to}',
    assignedBy: 'Asignada por {name}',
    edit: 'Editar asignación',
    delete: 'Eliminar asignación',
    deleteConfirmation: 'Se eliminará este período del historial de categorías. ' +
      'El período quedará como "sin categoría".',
    startsOn: 'Desde',
    endsOn: 'Hasta (vacío = vigente)',
    category: 'Categoría',
    subcategory: 'Subcategoría',
    save: 'Guardar',
    cancel: 'Cancelar',
    archived: 'archivada',
  },
  patientDiscardForm: {
    title: 'Archivar Paciente',
    confirmation: `Estás a punto de archivar a este paciente.
      Si lo haces, este paciente dejará de aparecer en la vista de turnos.`,
    confirmationWithDetails: 'Dejará de aparecer en turnos, calendario y rutas. ' +
      'Puedes reactivarlo desde Archivados o al ingresar su RUT de nuevo.',
    reason: 'Motivo',
    reasonRequired: 'Selecciona un motivo',
    note: 'Nota (opcional)',
    endsOn: 'Fecha de término de servicio',
    endsOnHint: 'Por defecto, la fecha de la última atención (o hoy si no tuvo).',
    submit: 'Archivar',
    error: 'El paciente no se puede archivar porque aún esta activo, es decir, tiene turnos futuros asignados.',
    inventoryWarning: 'Su domicilio aún tiene {supplies} insumo(s) con stock y {units} equipo(s). ' +
      'Puedes archivarlo igual y registrar después la devolución, el traslado o la baja ' +
      'desde la pestaña Inventario de su ficha.',
  },
  patientUndiscardForm: {
    title: 'Desarchivar Paciente',
    confirmation: `Estás a punto de desarchivar a este paciente.
      Si lo haces, este paciente volverá a aparecer en la vista de turnos.`,
    confirmationNewEpisode: 'El paciente vuelve a Activos como un nuevo ingreso: su fecha de ' +
      'inicio será hoy y se limpian la fecha de término y el motivo de archivo. ' +
      'Su historial, grupos, direcciones y precios se mantienen.',
    submit: 'Desarchivar',
    reactivate: 'Reactivar',
  },
  // Keys are the camelized Patient.discard_reasons values (see discardReasonLabel).
  discardReasons: {
    goalsMet: 'Alta · objetivos cumplidos / fin de tratamiento',
    deceased: 'Fallecimiento',
    hospitalizedOrInstitutionalized: 'Hospitalización o traslado a institución',
    changedProvider: 'Cambio de prestador',
    familyDecision: 'Decisión de la familia / del paciente',
    economicOrCoverage: 'Motivos económicos / término de cobertura',
    movedOutOfCoverage: 'Cambio de domicilio fuera de cobertura',
    createdByMistake: 'Ingreso duplicado o por error',
    other: 'Otro',
  },
  // Keys are the camelized ShiftChangeRequest.reason_codes values. Rows print the
  // server's humanReason; these label the history filter before any row loads.
  shiftChangeReasons: {
    codes: {
      representativeRequest: 'Solicitud del apoderado',
      caregiverPersonal: 'Motivos personales',
      caregiverHealth: 'Motivos de salud',
      routeChange: 'Cambios en la ruta',
      incident: 'Incidente',
      other: 'Otro',
    },
    withoutReason: 'Sin motivo estandarizado',
  },
  // Activos / Inactivos / Archivados currency (companies with care planning)
  patientStatus: {
    tabs: { active: 'Activos', inactive: 'Inactivos', discarded: 'Archivados' },
    columns: {
      status: 'Estado',
      lastShift: 'Última atención',
      discardReason: 'Motivo',
      discardedAt: 'Archivado el',
      endsOn: 'Fecha de término',
      discardedBy: 'Archivado por',
    },
    activeRequirementTooltip: 'Tiene requerimientos vigentes',
    bucket: { active: 'Activo', inactive: 'Inactivo', discarded: 'Archivado' },
    hint: {
      requirementOpen: 'Req. hasta {date}',
      requirementOpenEnded: 'Req. vigente',
      requirementFuture: 'Req. desde {date}',
      shiftScheduled: 'Turno {date}',
      serviceUntil: 'Servicio hasta {date}',
      requirementEnded: 'Sin requerimiento {ago}',
      requirementEndedToday: 'Requerimiento terminó hoy',
      noRecentShift: 'Sin atención {ago}',
      noRecentShiftToday: 'Atendido hoy · sin plan',
      neverServed: 'Nuevo · ingresó {ago}',
    },
    ago: {
      today: 'hoy',
      day: 'hace 1 día',
      days: 'hace {count} días',
      month: 'hace 1 mes',
      months: 'hace {count} meses',
      year: 'hace 1 año',
      years: 'hace {count} años',
    },
    searchHint: '+{count} en {tab}',
    inactiveEmpty: 'No hay pacientes inactivos: todos tienen un requerimiento vigente o un turno agendado.',
    archivedBanner: 'Archivado el {date}',
    archivedBy: 'por {name}',
    reactivated: 'Paciente reactivado',
  },
  patientDocument: {
    name: 'Nombre',
    documentUrl: 'Documento',
    document: 'Documento',
  },
  patientDocumentForm: {
    fieldRequired: 'Campo requerido',
    createTitle: 'Agregar Documento',
    updateTitle: 'Editar Documento',
    createSubmit: 'Agregar',
    updateSubmit: 'Guardar',
    fileSizeLimit: 'El documento debe pesar máximo 30MB.',
  },
  // Shifts
  shift: {
    startDate: 'Fecha Inicio',
    endDate: 'Fecha Término',
    startTime: 'Hora de inicio',
    endTime: 'Hora de término',
    patient: 'Paciente',
    caregiver: 'Profesional',
    caregiverCost: 'Pago a Profesional (líquido)',
    price: 'Precio',
    caregiverCostPerHour: 'Pago a Profesional por hora (líquido)',
    pricePerHour: 'Precio por hora',
  },
  shiftBatchCreateForm: {
    fieldRequired: 'Campo requerido',
    title: 'Agregar Turnos',
    submit: 'Crear Turnos',
    stepOneTitle: 'Paciente y Profesionales',
    stepOneSubtitle: 'Selecciona el paciente, los profesionales y la fecha de inicio',
    stepTwoTitle: 'Tipo de Turno',
    stepTwoSubtitle: 'Selecciona el tipo de turno',
    stepThreeTitle: 'Precios y Costos',
    stepThreeSubtitle: 'Ingresa los precios y costos de cada profesional',
    caregiverWeekShiftCost: 'Turno Semana',
    caregiverWeekendShiftCost: 'Turno Fin de Semana',
    weekShiftPrice: 'Turno Semana',
    weekendShiftPrice: 'Turno Fin de Semana',
    caregiverWeekShiftCostPerHour: 'Hora Semana',
    caregiverWeekendShiftCostPerHour: 'Hora Fin de Semana',
    weekShiftPricePerHour: 'Hora Semana',
    weekendShiftPricePerHour: 'Hora Fin de Semana',
    dayShift: 'Turno Día (8:00 - 20:00)',
    nightShift: 'Turno Noche (20:00 - 8:00)',
    caregivers: 'Profesionales',
    previous: 'Anterior',
    next: 'Continuar',
    caregiverCostTitle: 'Pago a Profesional (líquido)',
    priceTitle: 'Cobro al Paciente',
    withTaxBillTitle: '¿Con boleta de honorarios?',
    yes: 'Sí',
    no: 'No',
    twentyFourHoursInfo: `Los turnos que selecciones comienzan a partir de las {startTime} horas
      del día seleccionado y terminan a las {endTime} del día siguiente.`,
    caregiverHasSalaryInfo: `Este profesional tiene un sueldo configurado; sus turnos no generan pago por turno
      (se usará su configuración de sueldo).`,
    pricingLoadError: 'No se pudieron cargar los precios de este profesional. Recarga la página e intenta nuevamente.',
    customRangesInfo: `Agrega los horarios que necesites (máximo {max}). Luego marcarás, por día,
      cuáles hace cada profesional.`,
    addCustomRange: 'Agregar horario',
    removeCustomRange: 'Quitar horario',
    duplicateCustomRange: 'Este horario ya está en la lista',
    patientWithoutGroups: `Este paciente no pertenece a ningún grupo, por lo que no se le pueden asignar
      profesionales. Asígnalo a un grupo para poder crearle turnos.`,
  },
  shiftRecurrentCreateForm: {
    fieldRequired: 'Campo requerido',
    fieldPositive: 'Debe ser un número positivo',
    patientWithoutGroups: `Este paciente no pertenece a ningún grupo, por lo que no se le pueden asignar
      profesionales. Asígnalo a un grupo para poder crearle turnos.`,
    caregiverWithoutGroups: `Este profesional no pertenece a ningún grupo, por lo que no se le pueden asignar
      pacientes. Asígnalo a un grupo para poder crearle turnos.`,
    title: 'Crear Turnos',
    submit: 'Crear Turnos',
    shiftTypeTitle: 'Tipo de Turno',
    shiftTypeDay: 'Día (8:00 a 20:00)',
    shiftTypeNight: 'Noche (20:00 a 8:00)',
    shiftType24: '24 horas',
    shiftTypeCustom: 'Personalizado',
    recurrenceType: 'Recurrencia',
    recurrenceInterval: 'Repetir',
    recurrenceDays: 'Días de la semana',
    previous: 'Anterior',
    next: 'Continuar',
  },
  shiftForm: {
    fieldRequired: 'Campo requerido',
    patientWithoutGroups: `Este paciente no pertenece a ningún grupo, por lo que no se le pueden asignar
      profesionales. Asígnalo a un grupo para poder crearle turnos.`,
    caregiverWithoutGroups: `Este profesional no pertenece a ningún grupo, por lo que no se le pueden asignar
      pacientes. Asígnalo a un grupo para poder crearle turnos.`,
    editTitle: 'Editar Turno',
    newTitle: 'Crear Turno',
    editSubmit: 'Guardar Cambios',
    newSubmit: 'Crear Turno',
    shiftTypeTitle: 'Tipo de Turno',
    shiftTypeDay: 'Día (8:00 a 20:00)',
    shiftTypeNight: 'Noche (20:00 a 8:00)',
    shiftType24: '24 horas',
    shiftType24Info: 'Selecciona el horario de inicio y término del turno.',
    shiftTypeCustom: 'Personalizado',
    shiftTypeCustomStartInfo: 'Selecciona el horario de inicio del turno.',
    shiftTypeCustomEndInfo: 'Selecciona el horario de término del turno.',
    dateTitle: 'Fecha del Turno',
    dateMarkedShiftInfo: 'No es posible cambiar la fecha de un turno con asistencia marcada.',
    complianceCheckTitle: 'Importante: Verificación de Cumplimiento',
    complianceCheckClose: 'Entendido',
    complianceInitialText: `Los siguientes profesionales no cumplen con los límites
      que la ley establece para las jornadas de trabajo.`,
    pricingUpdateTitle: 'Actualización de Precios',
    pricingUpdateDescription: `La estructura de precios ha cambiado para esta combinación de paciente
      y profesional. ¿Deseas actualizar los valores del turno?`,
    pricingUpdateField: 'Campo',
    pricingUpdateCurrent: 'Actual',
    pricingUpdateNew: 'Nuevo',
    pricingUpdateAccept: 'Actualizar precios',
    pricingUpdateDecline: 'Mantener actuales',
    caregiverHasSalaryInfo: `Este profesional tiene un sueldo configurado.
      El pago al profesional se calculará automáticamente según su configuración de sueldo.`,
  },
  shiftDestroyForm: {
    title: 'Eliminar Turno',
    submit: 'Eliminar',
    confirmation: '¿Estás seguro que deseas eliminar este turno? Solo se puede eliminar si el turno se puede borrar.',
    notDeletableError: 'El turno no se pudo eliminar porque tiene información asociada que no se puede borrar.',
    invoicedWarning: 'Este turno ya fue facturado en un DTE. Al eliminarlo se creará una devolución por lo ' +
      'facturado, que se descontará en el próximo cobro.',
  },
  shiftSuspendForm: {
    suspendTitle: 'Suspender Turno',
    unsuspendTitle: 'Reactivar Turno',
    suspendSubmit: 'Suspender',
    unsuspendSubmit: 'Reactivar',
    suspendConfirmation: 'El profesional no asistirá, pero el turno se cobrará al cliente y ' +
      'se pagará al profesional igualmente. ¿Deseas suspender este turno?',
    unsuspendConfirmation: '¿Deseas reactivar este turno y volver a su estado normal?',
    suspendSuccess: 'Turno suspendido exitosamente!',
    unsuspendSuccess: 'Turno reactivado exitosamente!',
    suspendError: 'El turno no se pudo suspender. Solo se puede suspender desde 24 horas antes de ' +
      'su inicio y sin marcaje.',
    unsuspendError: 'No se pudo reactivar el turno. Inténtalo nuevamente.',
  },
  shiftBatchDestroyForm: {
    title: 'Detener servicio',
    addTitle: 'de {caregiver}',
    lastDate: 'Última fecha activo',
    explanation: `Selecciona la última fecha para la cual el servicio estará activo.
    Todos los turnos que se puedan borrar a partir de esa fecha serán eliminados.`,
    explanationWithCaregiver: `Selecciona la ultima fecha para la cual el servicio del profesional {caregiver}
    estará activo. Todos los turnos que se puedan borrar a partir de esa fecha serán eliminados.`,
    confirmation: '¿Estás seguro que deseas eliminar todos los turnos que se puedan borrar a partir de esa fecha?',
    confirmationWithCaregiver: `¿Estás seguro que deseas eliminar todos los turnos que se puedan borrar del paciente
    con este profesional a partir de esa fecha?`,
    submit: 'Sí, Eliminar',
    oldDateError: 'La fecha debe ser hoy o posterior',
    notFoundError: 'No hay turnos futuros a partir de esa fecha que se puedan borrar.',
  },
  shiftBatchUpdateForm: {
    title: 'Editar Turnos',
    explanation: 'Selecciona un nuevo profesional y las fechas para traspasar los turnos.',
    notFoundError: 'No hay turnos entre esas fechas para editar.',
    fieldRequired: 'Campo requerido',
    dateFuture: 'La fecha debe ser posterior a hoy',
  },

  shiftReportTextsTimeline: {
    title: 'Registros Escritos',
    close: 'Cerrar',
    noReportTexts: 'No hay registros escritos',
  },
  shiftShowReportTexts: {
    noReportTexts: 'No hay registros escritos',
    timelineTooltip: 'Ver todos los registros escritos',
  },
  // Salaries
  salaryForm: {
    createTitle: 'Nuevo Sueldo',
    editTitle: 'Editar Sueldo',
    baseSalary: 'Sueldo Base Líquido Mensual',
    amountPerShift: 'Variable por Turno',
    minimumShiftsThreshold: 'Turnos Mínimos (umbral)',
    minimumShiftsThresholdHint: 'Si es 0, todos los turnos reciben variable. Si es > 0, solo turnos extras.',
    startsOn: 'Fecha de Inicio',
    endsOn: 'Fecha de Fin (opcional)',
    endsOnHint: 'Dejar vacío si el sueldo está activo',
    cancel: 'Cancelar',
    save: 'Guardar',
    fieldRequired: 'Campo requerido',
    fieldPositiveNumber: 'Debe ser un número positivo',
    fieldInteger: 'Debe ser un número entero',
    fieldNonNegativeInteger: 'Debe ser un número entero no negativo',
    endsOnAfterStartsOn: 'Debe ser posterior a la fecha de inicio',
    saveError: 'Error al guardar el sueldo. Verifique que no existan sueldos superpuestos.',
  },
  salaryList: {
    title: 'Historial de Sueldos',
    newSalary: 'Nuevo Sueldo',
    activeSalary: 'Sueldo Activo',
    baseSalaryLabel: 'Sueldo Base Líquido',
    variableLabel: 'Variable',
    perShift: 'por turno',
    afterShifts: 'después de {count} turnos',
    noSalaries: 'Este profesional no tiene sueldos configurados.',
    loadError: 'Error al cargar los sueldos.',
    close: 'Cerrar',
    from: 'Desde',
    to: 'Hasta',
    threshold: 'Umbral',
    status: 'Estado',
    actions: 'Acciones',
    active: 'Activo',
    finished: 'Finalizado',
    confirmDeleteTitle: 'Confirmar Eliminación',
    confirmDeleteMessage: '¿Está seguro que desea eliminar este sueldo?',
    delete: 'Eliminar',
  },
  // Service Prices
  servicePriceForm: {
    fieldRequired: 'Campo requerido',
    fieldPositive: 'Debe ser un número mayor a 0',
    priceAlreadyExists: 'El precio para este servicio ya está definido.',
    withTaxBillTitle: '¿Con boleta de honorarios?',
    yes: 'Sí',
    no: 'No',
  },
  // User Session
  login: {
    passwordRequired: 'Contraseña requerida',
    emailRequired: 'Correo electrónico requerido',
    title: 'Iniciar sesión',
    subtitle: 'Ingresa tu correo electrónico y contraseña para entrar a tu cuenta.',
    email: 'Correo electrónico',
    password: 'Contraseña',
    submit: 'Iniciar sesión',
    noAccount: 'No tengo cuenta',
    forgotPassword: 'Olvidé mi contraseña',
    passwordUpdated: 'Contraseña actualizada correctamente',
    emailInvalid: 'Correo electrónico no es válido',
    passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
    accountUnlocked: 'Tu cuenta ha sido desbloqueada correctamente.',
  },
  editPassword: {
    passwordRequired: 'Contraseña requerida',
    passwordConfirmationRequired: 'La confirmación de la contraseña es requerida',
    passwordConfirmationMismatch: 'Las contraseñas no coinciden',
    title: 'Cambiar contraseña',
    subtitle: 'Ingresa la nueva contraseña para cambiarla.',
    passwordMinLength: 'La contraseña debe tener al menos 8 caracteres',
    passwordInvalid: 'La contraseña debe tener entre 8 y 128 caracteres.',
    tokenInvalid: 'El enlace ya no es válido o expiró.',
    requestNewLink: 'Solicitar un enlace nuevo',
    password: 'Contraseña',
    passwordConfirmation: 'Confirmar contraseña',
    submit: 'Cambiar contraseña',
    backToLogin: 'Volver al inicio de sesión',
  },
  recoverPassword: {
    emailInvalid: 'Correo electrónico no es válido',
    emailRequired: 'Correo electrónico requerido',
    title: 'Recuperar contraseña',
    subtitle: 'Ingresa tu correo electrónico para recibir las instrucciones de recuperación.',
    email: 'Correo electrónico',
    submit: 'Enviar instrucciones',
    backToLogin: 'Volver al inicio de sesión',
    tooManyRequests: 'Hiciste demasiadas solicitudes. Espera una hora e intenta nuevamente.',
    emailError: 'Ocurrió un error al enviar el correo de recuperación de contraseña. Por favor, intenta nuevamente.',
  },
  user: {
    signOutError: 'Hubo un error al cerrar sesión, inténtelo nuevamente.',
  },
  // The name and RUT an office user signs registros clínicos with
  userIdentity: {
    title: 'Tu nombre y RUT',
    intro: 'Para registrar en la ficha clínica necesitas tu nombre y RUT: quedan como autor de tus registros.',
    firstName: 'Nombre',
    lastName: 'Apellido',
    dni: 'RUT',
    fieldRequired: 'Este campo es requerido',
    invalidDni: 'El RUT ingresado no es válido',
    save: 'Guardar y continuar',
    cancel: 'Cancelar',
    saveError: 'No se pudo guardar tu nombre y RUT. Intenta nuevamente.',
  },
  userSession: {
    defaultError: 'Hubo un error inesperado, inténtalo nuevamente.',
  },
  common: {
    optional: 'Opcional',
    required: 'Requerido',
  },
  announcements: {
    title: 'Novedades',
    openLabel: 'Novedades',
    openLabelWithUnread: 'Novedades ({count} sin leer)',
    close: 'Cerrar',
    empty: 'No hay novedades por ahora.',
  },
  shiftImport: {
    title: 'Importar turnos desde Excel',
    subtitle: 'Sube la planilla del mes para crear los turnos masivamente. ' +
      'Columnas A y B: RUT del paciente y del profesional (según su encabezado, en cualquier orden), ' +
      'y una columna por día con el código de turno (o -1).',
    month: 'Mes',
    year: 'Año',
    file: 'Planilla (.xlsx)',
    submit: 'Analizar planilla',
    entryPoint: 'Importar desde Excel',
    fileRequired: 'Debes seleccionar una planilla',
    fileSizeLimit: 'El archivo no debe superar los 30MB',
    fileType: 'El archivo debe ser .xlsx',
    analyzing: 'Analizando la planilla…',
    committing: 'Creando los turnos…',
    previewTitle: 'Revisa antes de confirmar',
    wouldCreate: 'Turnos a crear',
    wouldDuplicate: 'Ya existentes (se omitirán)',
    wouldFail: 'Con errores (no se crearán)',
    confirm: 'Confirmar y crear turnos',
    completedTitle: 'Importación completada',
    completedWithWarningsTitle: 'Importación completada con advertencias',
    created: 'Turnos creados',
    duplicates: 'Duplicados omitidos',
    missingPatients: 'Pacientes no encontrados',
    missingCaregivers: 'Profesionales no encontrados',
    rowErrors: 'Filas con problemas',
    rowErrorLine: 'Fila {row}: {message}',
    rowErrorLines: 'Filas {rows}: {message}',
    rowErrorDnis: 'Paciente {patient} · Profesional {caregiver}',
    notCreatedHint: 'Estos registros no se crearon. Corrígelos y vuelve a importar.',
    reupload: 'Subir planilla corregida',
    periodTitle: 'Importación de turnos de {period}',
    confirmDialogTitle: '¿Confirmar y crear turnos?',
    confirmDialogText: 'Se crearán {count} turnos para {period}. ' +
      'Los turnos ya existentes se omitirán.',
    cancel: 'Cancelar',
    failed: 'No se pudo procesar la planilla.',
    genericError: 'Ocurrió un error al subir la planilla.',
  },
  routePlan: {
    title: 'Planificación de Rutas',
    newOptimization: 'Nueva Planificación',
    noAccessibleCareer: 'No tienes especialidades habilitadas para crear planificaciones',
    date: 'Fecha',
    status: 'Estado',
    totalTravelTime: 'Tiempo de Viaje Total',
    totalServiceTime: 'Tiempo de Servicio Total',
    setup: 'Crear Planificación de Rutas',
    caregivers: 'Profesionales',
    selectCaregivers: 'Seleccionar profesionales disponibles',
    caregiverHours: {
      title: 'Horario de cada profesional',
      subtitle: 'Ajusta el horario disponible de cada profesional para este día. ' +
        'Por defecto se usa el horario de la empresa.',
      invalid: 'La hora de inicio debe ser anterior a la hora de término.',
    },
    // Shared by the setup wizard hours rows and the board caregiver-edit dialog.
    lunchDuration: {
      label: 'Almuerzo',
      option30: '30 min',
      option60: '1 h',
    },
    visits: 'turnos',
    patient: 'Paciente',
    selectCareer: 'Especialidad',
    selectPatients: 'Seleccionar pacientes',
    durationMinutes: 'Duración',
    timeWindowStart: 'Desde',
    timeWindowEnd: 'Hasta',
    // Visit-specific hint: these shared Desde/Hasta labels also name caregiver hours.
    timeWindowEndHint: 'Hora límite en la que debe terminar la visita',
    fixedStartTime: 'Hora fija',
    fixedStartTimeHint: 'Se agendará dentro de ±1 hora de esta hora',
    fixedTimeRange: '(±1 h)',
    saveDraft: 'Guardar',
    savedAt: 'Guardado a las {time}',
    runOptimization: 'Ejecutar Planificación',
    optimizing: 'Optimizando rutas...',
    optimizationFailed: 'La optimización falló',
    optimizeOverlay: {
      title: 'Optimizando las rutas del día',
      hint: 'Con muchos turnos esto puede tardar cerca de un minuto. No cierres esta pestaña.',
      stageSave: 'Guardando el plan…',
      stageMatrix: 'Calculando distancias y tiempos de viaje…',
      stageSolve: 'Buscando la mejor combinación de rutas…',
      stageCalendar: 'Armando el calendario…',
    },
    arrivalTime: 'Llegada',
    departureTime: 'Salida',
    travelTime: 'Viaje',
    favoriteFallback: 'Asignado a un profesional fuera de los favoritos del paciente',
    applyAndCreateShifts: 'Aplicar y Crear Turnos',
    shiftsCreatedSuccessfully: 'Se crearon {count} turnos exitosamente',
    // Stepper
    stepDateAndCareer: 'Fecha y Especialidad',
    stepCaregivers: 'Profesionales',
    stepVisits: 'Turnos',
    selectedCount: '{count} de {total} seleccionados',
    noCoordinates: 'Sin dirección asignada',
    visitAddress: 'Dirección',
    fixedTimeShort: 'Hora fija',
    prioritizedShort: 'Prioritaria',
    prioritizedHint: 'Si el optimizador debe descartar visitas, esta se mantiene antes que ' +
      'otras de su misma categoría.',
    fixedStartTolerance: 'Tolerancia de hora fija (±)',
    fixedStartToleranceHint: 'Margen ± alrededor de las horas fijas. Por defecto de la empresa: {minutes} min.',
    // Expected visits (weekly-plan prefill)
    expected: {
      title: 'Plan semanal',
      status: 'no hay visitas esperadas para este día | ' +
        '1 visita esperada para este día | ' +
        '{count} visitas esperadas para este día',
      loadCta: 'Cargar 1 esperada | Cargar {count} esperadas',
      allLoaded: 'Visitas esperadas cargadas',
      loading: 'buscando visitas esperadas…',
      loadError: 'No se pudieron cargar las visitas esperadas del plan semanal.',
      blocked: '1 visita esperada cae en un bloqueo de horario del paciente y no se cargará | ' +
        '{count} visitas esperadas caen en bloqueos de horario del paciente y no se cargarán',
    },
    addAnotherVisit: 'Agregar otro turno',
    assignedCaregiver: 'Profesional asignado',
    minutes: 'min',
    attentions: 'turnos',
    coordinatesWarning: 'Algunos profesionales seleccionados no tienen dirección asignada',
    patientsCoordinatesWarning: 'Algunos pacientes seleccionados no tienen dirección asignada',
    // Quick add-address dialog
    addAddress: 'Agregar dirección',
    addressDialogTitle: 'Agregar dirección · {name}',
    addressRequiresLocation: 'Selecciona una dirección de la lista para fijar su ubicación en el mapa.',
    addressSaveError: 'No se pudo guardar la dirección. Inténtalo nuevamente.',
    saveAddress: 'Guardar dirección',
    confirm: 'Confirmar',
    requiredSkill: 'Subespecialidad requerida',
    requiredSkillHint: 'Sólo profesionales con esta subespecialidad pueden atender este turno',
    noRequiredSkill: 'Sin subespecialidad',
    skillCoverageWarning: 'Ningún profesional seleccionado tiene la subespecialidad requerida por estos ' +
      'turnos; quedarán sin asignar al optimizar:',
    // Results header
    totalTravelTimeLabel: 'Tiempo total de viaje',
    totalServiceTimeLabel: 'Tiempo total de servicio',
    serviceTimeTooltip: 'Solo incluye turnos asignados. No incluye almuerzo ni turnos existentes.',
    caregiverCountLabel: 'Profesionales',
    assignedVisitsLabel: 'Turnos asignados',
    home: 'Domicilio',
    // Confirmation
    confirmApply: 'Confirmar Aplicación',
    shiftsWillBeCreated: 'Se crearán {count} turnos para el {date}:',
    rejectedWontBeCreated: '{count} visitas rechazadas no se crearán',
    cancel: 'Cancelar',
    viewShift: 'Ver Turno',
    // Error messages
    saveError: 'Error al guardar el borrador',
    updateError: 'Error al actualizar la asignación',
    applyError: 'Error al aplicar la planificación',
    applyBlockedUnplacedShifts: 'No se puede aplicar: {count} turno(s) existente(s) quedaron ' +
      'sin ubicar en la ruta. Vuelve a optimizar para incluirlos antes de aplicar.',
    backToEdit: 'Volver a editar',
    confirmReset: '¿Desea volver a editar? Se perderán los resultados de la optimización, ' +
      'incluidas las visitas asignadas manualmente.',
    // Timeline tooltips
    totalWait: 'Espera total',
    extraWait: 'Espera extra',
    existingShift: 'Turno existente',
    notOptimized: 'sin optimizar',
    manualPlacement: 'Asignación manual',
    rescheduledFrom: 'movido de {time}',
    lunchBreak: 'Almuerzo ({duration})',
    // List
    actions: 'Acciones',
    loading: 'Cargando planificaciones...',
    emptyState: 'No hay planificaciones de rutas',
    // Groups
    groups: {
      label: 'Grupo',
      none: 'Sin grupo',
      locked: 'No se puede cambiar el grupo después de agregar profesionales o visitas.',
      loading: 'Cargando grupos, intenta de nuevo en un momento',
    },
    // Status labels
    statusDraft: 'Borrador',
    statusProcessing: 'Procesando',
    statusCompleted: 'Completado',
    statusFailed: 'Error',
    statusApplied: 'Aplicado',
    // Results
    requestedVisits: 'Turnos solicitados',
    noAssignments: 'Sin asignaciones',
    // Unassigned visits panel
    unassigned: {
      title: 'Visitas sin asignar',
      countChip: '{count} sin asignar',
      inputErrorTitle: 'Necesitan una corrección',
      inputErrorHint: 'No se podrán ubicar hasta corregir los datos o el equipo.',
      capacityTitle: 'Sin cupo',
      capacityHint: 'Son factibles, pero no alcanzaron a entrar. Agregue profesionales, ' +
        'amplíe las jornadas o relaje las ventanas horarias.',
      reoptimizeFoldIn: 'Reintentar (mantener ruta)',
      reoptimizeFull: 'Optimizar de nuevo',
      applyWarning: 'Se aplicará dejando {count} visita(s) sin asignar:',
      rejectedTitle: 'Rechazadas por el despachador',
      rejectedHint: 'No se crearán turnos para estas visitas al aplicar. Acéptelas nuevamente ' +
        'o re-optimice para reubicarlas (al mantener la ruta, las rechazadas quedan libres).',
      rejectedDetail: 'Asignada a {name} ({start} - {end})',
      reaccept: 'Aceptar nuevamente',
    },
    // Simplified review flow
    steps: {
      configure: 'Configurar',
      review: 'Revisar y ajustar',
      apply: 'Aplicar',
    },
    viewTabs: {
      calendar: 'Calendario',
      map: 'Mapa',
      timeline: 'Cronograma',
      list: 'Lista',
    },
    pending: {
      title: 'Pendientes',
      summary: '{placed} de {total} visitas asignadas',
      ready: 'Ruta lista — todas las visitas asignadas',
      caregiversLine: '{used} de {total} profesionales · {travel} de viaje',
      resolveCta: 'Resolver {count} pendiente(s)',
      reoptimizeFull: 'Optimizar todo de nuevo',
      improved: '{count} visita(s) más asignada(s)',
      noChange: 'La asignación no cambió. Pruebe otra corrección o asigne manualmente.',
      applyExcluded: 'No se crearán {count} visita(s):',
      applyMissingExpected: '{count} visita(s) esperada(s) sin cubrir según el plan semanal:',
      applyMovedShifts: '{count} turno(s) existente(s) se moverán al aplicar:',
      reasons: {
        ALL_CAREGIVERS_BLOCKED: 'Todos sus profesionales están bloqueados',
        MISSING_GEOCODE: 'Falta la dirección del paciente',
        SKILL_NOT_IN_FLEET: 'Requiere una subespecialidad que nadie tiene',
        EMPTY_TIME_WINDOW: 'La visita no tiene horario definido',
        INVALID_TIME_WINDOW: 'El horario de la visita es inválido',
        TIME_WINDOW_INFEASIBLE: 'Fuera del horario de los profesionales',
        EXCEEDS_SHIFT_OR_CAPACITY: 'Sin cupo en la jornada de {name}',
        OVERLAPS_EXISTING_SHIFT: 'Choca con un turno existente de {name}',
        NO_CAPACITY_GENERIC: 'Sin cupo en la ruta optimizada',
        rejected: 'Rechazada por ti — estaba con {name}',
      },
      actions: {
        adjustWindow: 'Ajustar horario',
        adjustWindowImplication: 'Cambia la hora fija o la ventana de la visita, ' +
          'luego reoptimiza manteniendo el resto de la ruta.',
        extendShift: 'Extender turno de {name}',
        extendShiftShort: 'Extender turno',
        extendShiftImplication: 'Amplía la jornada del profesional para que quepa la visita, ' +
          'luego reoptimiza manteniendo el resto de la ruta.',
        pin: 'Asignar manualmente',
        pinImplication: 'Asigna el profesional que elijas a esta visita, ' +
          'aunque el optimizador no lo haya hecho.',
        clearSkill: 'Quitar requisito',
        clearSkillImplication: 'Elimina la subespecialidad requerida para que ' +
          'cualquier profesional pueda atenderla.',
        addCaregiver: 'Agregar profesional',
        addCaregiverImplication: 'Suma otro profesional al plan y vuelve a optimizar ' +
          'para crear más cupo.',
        reaccept: 'Aceptar nuevamente',
        reacceptImplication: 'Vuelve a incluir esta visita; se creará su turno al aplicar.',
        managePreferences: 'Gestionar profesionales',
        managePreferencesImplication: 'Abre el perfil del paciente para desbloquear ' +
          'a un profesional.',
        fixAddress: 'Corregir dirección',
        fixAddressImplication: 'Abre el paciente para corregir su dirección y coordenadas.',
      },
      resolver: {
        title: 'Resolver pendientes',
        step: '{current} de {total}',
        skip: 'Omitir',
        finish: 'Reintentar y ver resultado',
        close: 'Cerrar',
      },
    },
    // Visit editor dialog (click a visit on the board)
    visitForm: {
      requirementTitle: 'Requerimiento del paciente',
      between: 'Entre {start} y {end}',
      requirementTime: 'Horario',
      caregiver: 'Profesional',
      unassigned: 'Sin asignar',
      blocked: 'Bloqueado para este paciente',
      unplace: 'Quitar de la ruta',
      remove: 'Eliminar visita',
      removeConfirm: '¿Eliminar esta visita del plan?',
      save: 'Guardar',
      saveError: 'No se pudo guardar la visita.',
    },
    // "+ Agregar visita" (left panel)
    addVisit: {
      cta: 'Agregar visita',
      title: 'Agregar visita',
      subtitle: 'Se agrega como pendiente; luego arrástrala o asígnala en el calendario.',
      subtitleAt: 'Se creará con hora fija y se asignará a {name}.',
      placementFailed: 'La visita quedó pendiente: no se pudo asignar en ese horario.',
      window: 'Ventana horaria',
      timing: 'Horario',
      windowHint: 'La visita queda pendiente y podrá ubicarse dentro de esta ventana.',
      fixedHint: 'La visita tiene una hora exacta de inicio.',
      details: 'Detalles adicionales',
      save: 'Agregar',
    },
    // Existing shifts on the board (grey blocks)
    shiftEdit: {
      existingShift: 'Turno existente',
      requirementTitle: 'Turno comprometido',
      movedTooltip: 'Modificado · original {time}',
      originalCaregiver: 'Profesional original: {name}',
      keptTooltip: 'Sin optimizar: se mantiene en su horario comprometido',
      notMovable: 'No editable (iniciado, pasado o parte de una cadena de cuidado)',
      unplannedTooltip: 'Turno agregado después de optimizar: no fue considerado por la ruta.',
      unplannedChip: 'Nuevo desde la optimización',
      subtitle: 'El cambio se aplica al turno real al presionar "Aplicar y crear turnos".',
      startTime: 'Inicio',
      revert: 'Restablecer original',
      saveError: 'No se pudo mover el turno.',
    },
    // "+ Agregar profesional" (left panel)
    addCaregiver: {
      cta: 'Agregar profesional',
      title: 'Agregar profesional',
      subtitle: 'Se agrega una columna al calendario con su disponibilidad.',
      availability: 'Disponibilidad',
      availabilityHint: 'Franja del día en la que puede recibir visitas; fuera de ella su ' +
        'columna se muestra sombreada.',
      from: 'Disponible desde',
      to: 'Disponible hasta',
      empty: 'No hay profesionales disponibles para agregar.',
      save: 'Agregar',
    },
    // Working-hours editor opened from the calendar heading (route-caregiver-edit-dialog.vue)
    editCaregiver: {
      title: 'Horario de {name}',
      subtitle: 'Cambiar el horario solo actualiza el sombreado del calendario; las visitas ' +
        'ya asignadas no se mueven.',
      lunch: 'Inicio del almuerzo',
      strandedWarning: '{count} visita(s) quedarán fuera del nuevo horario. Muévelas ' +
        'manualmente si es necesario.',
      invalidWindow: 'La hora de inicio debe ser anterior a la hora de término.',
      save: 'Guardar',
    },
    // Blocked-professional confirmation (route-blocked-confirm-dialog.vue)
    blockedOverride: {
      title: 'Profesional bloqueado',
      message: '{caregiver} está bloqueado para {patient}. ¿Quieres asignarlo de todos modos?',
      hint: 'El bloqueo se definió en las preferencias del paciente. La asignación quedará ' +
        'registrada como confirmada por ti.',
      confirm: 'Asignar de todos modos',
      cancel: 'Cancelar',
    },
    // Daily board (route-plan-board.vue)
    board: {
      pending: 'Pendientes ({count})',
      noCategory: 'Sin categoría',
      prioritized: 'Prioritaria',
      categoryFilter: 'Filtrar por categoría',
      hint: 'Arrastra una visita pendiente al calendario para asignarla, o haz clic en ' +
        'una visita para editarla.',
      allPlaced: 'No hay visitas pendientes. Todas están ubicadas.',
      showPending: 'Ver pendientes ({count})',
      placedSummary: '{placed} de {total} visitas asignadas',
      applyAndCreate: 'Aplicar y Crear Turnos',
      applySummary: 'Se crearán {count} turno(s) y se notificará a los profesionales.',
      applyDuplicateWarning: '{count} visita(s) se omitirán porque el paciente ya tiene un turno ' +
        'en ese horario:',
      applySkipped: '{count} visita(s) omitida(s) por turnos duplicados.',
      applyError: 'No se pudo aplicar la planificación.',
      applyBlockedTitle: 'No se puede aplicar todavía',
      applyBlockedHint: 'Corrige estos puntos en el tablero y vuelve a intentarlo:',
      applyWarningsTitle: 'Advertencias (no impiden aplicar):',
      applyBlockedRefresh: 'El plan cambió al confirmar. Revisa los puntos actualizados.',
      previewError: 'No se pudo cargar la vista previa de la aplicación.',
      visitSaved: 'Visita guardada.',
      unassigned: 'Visita devuelta a pendientes.',
      dropToUnassign: 'Suelta aquí para quitarla de la ruta',
      removeError: 'No se pudo eliminar la visita.',
      fixedAt: 'Hora fija {time}',
      noWindow: 'Sin ventana horaria',
      placePrompt: '¿Qué visita pones aquí?',
    },
    // Day-coverage dialog (route-plan-coverage-dialog.vue)
    coverage: {
      cta: 'Cobertura del día',
      title: 'Cobertura del día',
      progress: '{covered} de {total} requerimientos cubiertos',
      columns: {
        missing: 'Falta cubrir',
        inProcess: 'En proceso',
        covered: 'Cubierto',
      },
      extraChip: 'Extra',
      coveredByShift: 'Turno ya agendado',
      fixedAt: '{time} fija (±1 h)',
      noTime: 'Sin horario definido',
      noRequirement: 'Sin requerimiento asociado',
      preferred: 'Solicitado: {name}',
      rejectedWarning: 'La asignación fue rechazada por el profesional',
      blockedChip: 'Bloqueado',
      blockedNote: '1 requerimiento cae en un bloqueo de horario del paciente | ' +
        '{count} requerimientos caen en bloqueos de horario del paciente',
      scheduleBlock: 'Dentro de un bloqueo de horario del paciente: {description}',
      timeDrift: 'Fuera del horario requerido',
      caregiverDrift: 'Distinto del profesional solicitado ({name})',
      doubleCoverage: 'El paciente ya tiene un turno existente en ese horario: ' +
        '{name}, {start}–{end}',
      quickAdd: 'Agregar',
      addAllMissing: 'Agregar todas las faltantes',
      addProgress: 'Agregando {done} de {total}…',
      addError: 'No se pudo agregar la visita.',
      bulkPartialError: '{count} visita(s) no se pudieron agregar.',
      loadError: 'No se pudo cargar la cobertura.',
      retry: 'Reintentar',
      emptyNoCarePlanning: 'La planificación de cuidados no está habilitada para tu empresa.',
      emptyNoRequirements: 'No hay requerimientos para esta especialidad, grupo y fecha.',
    },
    // Remediations
    remediation: {
      editVisit: 'Editar ventana / duración',
      pin: 'Fijar manualmente',
      extendShift: 'Extender turno de {name}',
      clearSkill: 'Quitar subespecialidad',
      selectCaregiver: 'Profesional',
      save: 'Guardar',
      skillPinHint: 'Esta visita requiere una subespecialidad; si el profesional elegido no la ' +
        'tiene, quedará sin asignar al optimizar.',
      fixAddress: 'Corregir dirección',
      managePreferences: 'Gestionar profesionales',
      editVisitTitle: 'Ajustar horario de la visita',
      windowModeFixed: 'Hora fija',
      windowModeRange: 'Rango horario',
      fixedStartTime: 'Hora fija',
      fixedStartHint: 'Se agendará dentro de ±1 hora de esta hora.',
      addCaregiverTitle: 'Agregar profesional al plan',
      addCaregiverHint: 'Suma un profesional para crear más cupo. Se vuelve a optimizar al agregar.',
      addCaregiverEmpty: 'No hay más profesionales disponibles para esta especialidad.',
      noBlockingCaregiver: 'No hay un profesional asociado para extender el turno.',
    },
    // Validation
    validation: {
      dateRequired: 'La fecha es obligatoria',
      careerRequired: 'La especialidad es obligatoria',
      atLeastOneCaregiver: 'Seleccione al menos un profesional',
      atLeastOneVisit: 'Agregue al menos un turno',
      patientRequired: 'El paciente es obligatorio',
      durationRequired: 'La duración es obligatoria',
      durationPositive: 'La duración debe ser mayor a 0',
      fixedTimeRequired: 'La hora fija es obligatoria',
      timeWindowRequired: 'El horario es obligatorio',
      windowTooShort: 'La ventana debe alcanzar para la duración: la visita debe poder ' +
        'terminar antes de la hora "Hasta"',
      groupRequired: 'El grupo es obligatorio',
      fixedStartOffsetPositive: 'La tolerancia debe ser mayor a 0',
      fixedStartOffsetMax: 'La tolerancia no puede superar las 12 horas (720 min)',
    },
  },
  // Company settings: e-invoicing connection and profile
  taxSettings: {
    title: 'Facturación electrónica',
    subtitle: 'Conecta la empresa con el proveedor de DTEs y elige cómo emite.',
    connectionTitle: 'Conexión con el SII',
    connectionSubtitle: 'Kuido emite los DTEs a nombre de la empresa con estas credenciales.',
    identification: 'Identificación',
    fields: {
      company: 'Empresa',
      registeredName: 'Razón social en el SII',
      certificate: 'Certificado digital',
    },
    certificatePresent: 'Sí',
    certificateAbsent: 'No — sólo boletas',
    unsavedChanges: 'Tienes cambios sin guardar.',
    // What the company can actually issue right now, from the readiness the
    // profile computes per document kind. Shown only once connected: before
    // that the status chip already says everything there is to say.
    readiness: {
      both: 'Puede emitir facturas y boletas.',
      invoiceOnly: 'Puede emitir facturas. Las boletas aún no están disponibles.',
      receiptOnly: 'Puede emitir boletas. Las facturas aún no están disponibles.',
      none: 'Todavía no puede emitir DTEs.',
    },
    status: {
      disconnected: 'Sin conectar',
      connected: 'Conectada',
      invalid: 'Credencial inválida',
      expired: 'Credencial vencida',
      missing: 'Sin credencial',
    },
    webhook: {
      notConfigured: 'Las notificaciones del proveedor aún no están configuradas; los DTEs se ' +
        'sincronizan cada 30 minutos.',
      failed: 'No se pudieron activar las notificaciones del proveedor ({error}); los DTEs se ' +
        'sincronizan cada 30 minutos.',
    },
    companyTaxIdMissing: 'La empresa no tiene RUT configurado. Pídele a Kuido que lo agregue en la ' +
      'administración antes de conectarla.',
    refresh: 'Actualizar estado',
    refreshed: 'Estado actualizado.',
    refreshError: 'No se pudo consultar al proveedor.',
    saved: 'Cambios guardados.',
    saveError: 'No se pudieron guardar los cambios.',
    enrol: {
      connect: 'Conectar con el proveedor',
      update: 'Actualizar credenciales',
      explanation: 'Ingresa las credenciales del SII de la persona que firma por la empresa. Se usan ' +
        'una vez para validar la conexión y no se guardan en Kuido.',
      authorityUserTaxId: 'RUT del usuario SII',
      authorityUserTaxIdHint: 'La persona (representante legal o usuario autorizado) dueña de la clave.',
      authorityPassword: 'Clave del SII',
      certificatePassword: 'Clave del certificado digital',
      certificatePasswordHint: 'La del certificado con que se firman las facturas; el archivo no es necesario.',
      submit: 'Conectar',
      done: 'Empresa conectada: ya puede emitir DTEs desde Cobros (recarga la página).',
      required: 'Obligatorio',
      errors: {
        credentialsRefused: 'El proveedor rechazó las credenciales: {detail}',
        notEnrolled: 'El proveedor no encontró la empresa: {detail}',
        providerUnavailable: 'El proveedor no está disponible en este momento; intenta más tarde.',
        unknown: 'No se pudo conectar la empresa.',
      },
    },
    taxCategories: {
      standard: 'Afecta a IVA',
      exempt: 'Exenta de IVA',
    },
    documentKinds: {
      invoice: 'Factura',
      receipt: 'Boleta',
    },
    choices: {
      title: 'Cómo emite la empresa',
      choicesSubtitle: 'Definen qué DTE se emite y cómo se calculan los impuestos.',
      rulesTitle: 'Reglas de emisión',
      taxCategory: 'Categoría de impuesto de los servicios',
      taxCategoryHint: 'Decide si los DTEs salen afectos a IVA o exentos.',
      pricesIncludeTax: 'Los precios de los turnos incluyen IVA',
      pricesIncludeTaxHint: 'Los montos de los turnos ya vienen con IVA; el neto se calcula ' +
        'al emitir.',
      documentKind: 'DTE para personas naturales',
      documentKindHint: 'Las organizaciones siempre reciben factura. Con precios IVA incluido, la ' +
        'boleta calza exactamente con el cobro; la factura puede quedar un peso por debajo.',
      save: 'Guardar',
    },
  },
  // Charge closures & tax documents
  chargeClosures: {
    cancel: 'Cancelar',
    close: 'Cerrar',
    kinds: {
      invoice: 'Factura electrónica',
      receipt: 'Boleta electrónica',
      creditNote: 'Nota de crédito electrónica',
      debitNote: 'Nota de débito electrónica',
      feeReceipt: 'Boleta de honorarios electrónica',
    },
    // How far a period got towards being billed. One vocabulary: the Cobros row
    // paints its emit action from the same facts, and the two must agree.
    state: {
      unemitted: 'Sin emitir',
      emitting: 'Emitiendo',
      emitted: 'Emitido',
      rejected: 'Rechazado',
      failed: 'Falló',
      voided: 'Anulado',
    },
    // The Cobros row's emit action, which says what already happened to the
    // period before it says what clicking will do.
    // Why an emission did not produce a usable DTE, one sentence each, naming
    // the next step. Keyed by tax_documents.failure_reason.
    failureReason: {
      credentials: 'Las credenciales del SII no permiten emitir. Reconecta la empresa en ' +
        'Configuración › Facturación electrónica.',
      providerUnconfigured: 'Falta configurar la conexión con el proveedor. Escríbele a Kuido.',
      unauthorized: 'Kuido no pudo autenticarse con el proveedor. Escríbele a Kuido.',
      notFound: 'El proveedor no reconoció a la empresa. Escríbele a Kuido.',
      conflict: 'El proveedor ya tiene un DTE con estos datos. Escríbele a Kuido.',
      unavailable: 'El servicio de facturación no estuvo disponible. Reintenta en unos minutos.',
      rateLimited: 'Se alcanzó el límite de envíos del proveedor. Reintenta en unos minutos.',
      notCreated: 'El proveedor no creó el DTE. Emite uno nuevo.',
      rejected: 'La autoridad tributaria rechazó el DTE. Corrige los datos y emite uno nuevo.',
      withdrawn: 'El cierre dejó de esperar este DTE.',
      unknown: 'No se pudo emitir el DTE. Reintenta o escríbele a Kuido.',
    },
    emitAction: {
      idle: 'Emitir DTE',
      emitting: 'Emisión en curso; el folio llega en unos minutos',
      emitted: 'DTE emitido; revísalo en DTEs',
      partial: 'Hay turnos o ajustes sin facturar desde el último DTE; emite uno complementario',
      failed: 'La emisión falló; reinténtala en DTEs',
      unemitted: 'Hay un DTE pendiente de emitir; emítelo en DTEs',
    },
    emit: {
      title: 'Emitir DTE',
      document: 'Documento',
      recipient: 'Receptor',
      registeredAs: 'Según el SII: {name}',
      partyUnavailable: 'No se pudo consultar el SII; el receptor se validará al emitir.',
      partyNotFound: 'El SII no tiene registro de este receptor; se validará al emitir.',
      noRepresentative: 'El paciente no tiene apoderado: el DTE necesita un receptor.',
      invalidTaxId: 'El {label} del apoderado no es válido.',
      unregistered: 'El receptor no está registrado en el SII; no se puede emitir.',
      nothingToBill: 'No hay turnos por facturar en el período.',
      providerNotReady: 'No hay un proveedor listo para emitir {kind}: revisa las cuentas y rutas ' +
        'de la empresa en la administración.',
      alreadyInvoiced: '{count} turnos del período ya están en un DTE anterior ({total}) ' +
        'y no se incluyen.',
      shifts: 'Turnos ({count})',
      adjustments: 'Ajustes',
      taxable: 'Neto',
      exempt: 'Exento',
      tax: 'IVA ({rate})',
      documentTotal: 'Total',
      roundingDelta: 'Se emite por {delta} menos que el cobro ({closureTotal}).',
      roundingExplained: 'Con IVA incluido en los precios no existe un neto entero cuyo IVA ' +
        'sume exactamente el total del cobro, así que el DTE queda unos pesos por debajo.',
      asynchronous: 'El DTE se envía al SII al confirmar; el folio llega en unos minutos.',
      willEmail: 'Cuando el SII lo acepte, se enviará automáticamente a {email}, ' +
        'junto con el detalle de los turnos.',
      withCopy: '{email} con copia a {copied}',
      willNotEmail: 'Ningún apoderado que recibe cobros tiene correo registrado: el DTE no se ' +
        'enviará por correo y tendrás que hacerlo llegar tú.',
      totalsChanged: 'Los montos cambiaron desde la vista previa; revisa los nuevos valores.',
      previewError: 'No se pudo calcular el cobro del período.',
      createError: 'No se pudo preparar el DTE del período.',
      documentError: 'No se pudo enviar el DTE. Reintenta aquí o desde DTEs.',
      confirm: 'Emitir',
      retry: 'Reintentar emisión',
    },
    list: {
      title: 'DTEs',
      window: 'Se muestran los cierres de los últimos 12 meses.',
      search: 'Buscar por paciente, receptor o folio',
      backToCharges: 'Volver a cobros',
      loading: 'Cargando los cierres...',
      empty: 'No hay cierres de cobro',
      patient: 'Paciente',
      period: 'Período',
      recipient: 'Receptor',
      total: 'Total',
      state: 'Estado',
      document: 'Documento',
      noDocument: 'Sin DTE',
      detail: 'Ver detalle',
      chargesPdf: 'PDF del cobro',
      documentPdf: 'PDF del DTE',
      emit: 'Emitir',
      retry: 'Reintentar',
      void: 'Anular cierre',
      reverse: 'Anular con NC',
      reverseConfirm: 'Emitir nota de crédito',
      reverseTitle: 'Anular con nota de crédito',
      reverseBody: 'Se emitirá una nota de crédito que anula {document} de {patient} ({from} – {to}). ' +
        'Cuando la autoridad la acepte, los turnos del período volverán a estar disponibles ' +
        'para un nuevo cierre.',
      reverseDeadlinePassed: 'El plazo para anular este DTE con nota de crédito venció el {date}; ' +
        'la autoridad puede no reconocer la anulación.',
      reversed: 'Nota de crédito enviada a la autoridad tributaria.',
      reverseError: 'No se pudo emitir la nota de crédito.',
      voidTitle: 'Anular cierre de cobro',
      voidBody: 'Los turnos de {patient} entre el {from} y el {to} volverán a estar disponibles ' +
        'para un nuevo cierre. El cierre queda como historial.',
      emitted: 'DTE enviado a la autoridad tributaria; el folio llegará en unos minutos.',
      retried: 'Emisión reintentada.',
      voided: 'Cierre anulado.',
      emitError: 'No se pudo emitir el DTE.',
      voidError: 'No se pudo anular el cierre.',
    },
    detail: {
      title: 'Detalle del cierre',
      loadError: 'No se pudo cargar el cierre.',
      period: 'Del {from} al {to}',
      recipient: 'Receptor: {name} ({taxId})',
      roundingDelta: 'Emitido {delta} por debajo del cobro por el redondeo del IVA.',
      deliveredAt: 'Enviado por correo el {date}.',
      noDocument: 'Este cierre no tiene un DTE vigente.',
      date: 'Fecha',
      description: 'Descripción',
      quantity: 'Cantidad',
      unitPrice: 'Precio',
      amount: 'Monto',
      total: 'Total',
    },
  },
};
